var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _rect, _circle8, _circle9, _rect2, _circle10, _circle11, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMetabolicAnalysisActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9,
    stroke: "#4061A3"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.01638,
    cy: 3.08571,
    r: 1.08571,
    fill: "#4061A3"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.36013,
    cy: 11.074,
    r: 1.08571,
    fill: "#4061A3"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.27419,
    cy: 14.7654,
    r: 1.08571,
    fill: "#4061A3"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.80056,
    cy: 11.4002,
    r: 1.08571,
    fill: "#4061A3"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.3767,
    cy: 15.0911,
    r: 1.08571,
    fill: "#4061A3"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.08571,
    cy: 6.77761,
    r: 1.08571,
    fill: "#4061A3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.82227,
    y: 2.5332,
    width: 1.12683,
    height: 4.7831,
    transform: "rotate(39.2241 8.82227 2.5332)",
    fill: "#4061A3"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.8091,
    cy: 5.87128,
    r: 1.08571,
    transform: "rotate(-39.299 12.8091 5.87128)",
    fill: "#4061A3"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.8784,
    cy: 10.5842,
    r: 1.08571,
    transform: "rotate(-39.299 12.8784 10.5842)",
    fill: "#4061A3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.2324,
    y: 6.30469,
    width: 1.14359,
    height: 4.01714,
    transform: "rotate(-0.954161 12.2324 6.30469)",
    fill: "#4061A3"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.4864,
    cy: 8.18097,
    r: 1.08571,
    transform: "rotate(-127.321 10.4864 8.18097)",
    fill: "#4061A3"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.1993,
    cy: 8.27424,
    r: 1.08571,
    transform: "rotate(-127.321 15.1993 8.27424)",
    fill: "#4061A3"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10.9043,
    y: 8.79297,
    width: 1.14434,
    height: 4.01714,
    transform: "rotate(-89.5654 10.9043 8.79297)",
    fill: "#4061A3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetabolicAnalysisActive);
export default __webpack_public_path__ + "static/media/metabolic_analysis_active.59a2acb1a493bc69685cb1d893343aae.svg";
export { ForwardRef as ReactComponent };